import { render, staticRenderFns } from "./ModalDeleteFile.vue?vue&type=template&id=2a60b780&scoped=true&"
import script from "./ModalDeleteFile.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60b780",
  null
  
)

export default component.exports